// Customer module routes for use in main router
export const customerRoutes = [
    {
        path: 'customers/list',
        name: 'CustomersList',
        component: () => import('./views/CustomersList.vue')
    },
    {
        path: 'customers/invoices',
        name: 'Invoices',
        component: () => import('./views/Invoices.vue')
    },
    {
        path: 'customers/items',
        name: 'CustomersItems',
        component: () => import('./views/CustomersItems.vue')
    },
    {
        path: 'customers/refund',
        name: 'CustomerRefund',
        component: () => import('./views/CustomerRefund.vue')
    },
    {
        path: 'customers/receive-payment',
        name: 'ReceivePayment',
        component: () => import('./views/ReceivePayment.vue')
    },
    {
        path: 'customers/prepayment',
        name: 'CustomerPrepayment',
        component: () => import('./views/CustomerPrepayment.vue')
    },
    {
        path: 'customers/center',
        name: 'CustomerCenter',
        component: () => import('./views/CustomerCenter.vue')
    },
    {
        path: 'customers/new',
        name: 'NewCustomer',
        component: () => import('./views/NewCustomer.vue')
    },
    {
        path: 'customers/edit/:customerId',
        name: 'EditCustomer',
        component: () => import('./views/EditCustomer.vue')
    },
    {
        path: 'customers/new-invoice',
        name: 'CustomerAddNewInvoice',
        component: () => import('./views/CustomerAddNewInvoice.vue')
    },
    {
        path: 'customers/create-invoice',
        name: 'CustomerCreateInvoice',
        component: () => import('./views/CustomerCreateInvoice.vue')
    },
    {
        path: 'customers/new-credit-memo',
        name: 'CustomerNewCreditMemo',
        component: () => import('./views/CustomerNewCreditMemo.vue')
    },
    {
        path: 'customers/new-cash-sale',
        name: 'NewCashSale',
        component: () => import('./views/NewCashSale.vue')
    },
    {
        path: 'customers/new-service-item',
        name: 'NewCustomerServiceItem',
        component: () => import('./views/CustomerServiceItem.vue')
    },
    {
        path: 'customers/new-inventory-item',
        name: 'NewCustomerInventoryItem',
        component: () => import('@/modules/inventory/views/NewInventoryItem.vue')
    },
    {
        path: 'customers/new-non-inventory-item',
        name: 'NewCustomerNonInventoryItem',
        component: () => import('./views/CustomerNonInventoryItem.vue')
    },
    {
        path: 'add-consultant',
        name: 'AddCustomerConsultant',
        component: () => import('./views/CustomerAddConsultant.vue')
    },
    {
        path: 'customers/edit-consultant/:consultantId',
        name: 'EditCustomerConsultant',
        component: () => import('./views/CustomerEditConsultant.vue')
    },
    {
        path: 'customers/edit-multiple-customer-consultant/:consultantId',
        name: 'EditMultipleCustomerConsultant',
        component: () => import('./views/EditMultipleCustomerConsultant.vue')
    },
    {
        path: 'new-inventory-assembly',
        name: 'NewCustomerInventoryAssembly',
        component: () => import('@/modules/inventory/views/NewInventoryAssembly.vue')
    }
];
